// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1O8Qw","content":"Consent_content__19tWE","footer":"Consent_footer__Ifh9s"};